declare namespace $ {

	type $mol_button_minor__hint_shm_agent_history_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_agent_history_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_history_3 = $mol_type_enforce<
		ReturnType< $shm_agent_history['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_list__rows_shm_agent_history_4 = $mol_type_enforce<
		ReturnType< $shm_agent_history['catalog_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_agent_history_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_history_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_agent_history_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_agent_history_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_agent_history_9 = $mol_type_enforce<
		ReturnType< $shm_agent_history['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_agent_history_10 = $mol_type_enforce<
		ReturnType< $shm_agent_history['detail_sections'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_agent_message_text__text_shm_agent_history_11 = $mol_type_enforce<
		ReturnType< $shm_agent_history['user_text'] >
		,
		ReturnType< $shm_agent_message_text['text'] >
	>
	type $shm_agent_message_card__role_key_shm_agent_history_12 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_message_card['role_key'] >
	>
	type $shm_agent_message_card__role_shm_agent_history_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_message_card['role'] >
	>
	type $shm_agent_message_card__time_shm_agent_history_14 = $mol_type_enforce<
		ReturnType< $shm_agent_history['user_time'] >
		,
		ReturnType< $shm_agent_message_card['time'] >
	>
	type $shm_agent_message_card__text_shm_agent_history_15 = $mol_type_enforce<
		ReturnType< $shm_agent_history['user_text'] >
		,
		ReturnType< $shm_agent_message_card['text'] >
	>
	type $shm_agent_message_card__content_shm_agent_history_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_agent_message_card['content'] >
	>
	type $mol_view__sub_shm_agent_history_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_shm_agent_history_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_view__sub_shm_agent_history_19 = $mol_type_enforce<
		ReturnType< $shm_agent_history['previous_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_shm_agent_history_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $shm_agent_message_text__text_shm_agent_history_21 = $mol_type_enforce<
		ReturnType< $shm_agent_history['previous_text'] >
		,
		ReturnType< $shm_agent_message_text['text'] >
	>
	type $mol_view__sub_shm_agent_history_22 = $mol_type_enforce<
		ReturnType< $shm_agent_history['last_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_shm_agent_history_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $shm_agent_message_text__text_shm_agent_history_24 = $mol_type_enforce<
		ReturnType< $shm_agent_history['last_text'] >
		,
		ReturnType< $shm_agent_message_text['text'] >
	>
	type $mol_page__title_shm_agent_history_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_agent_history_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_agent_history_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_shm_agent_history_28 = $mol_type_enforce<
		ReturnType< $shm_agent_history['catalog_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_agent_history_29 = $mol_type_enforce<
		ReturnType< $shm_agent_history['catalog_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__click_shm_agent_history_30 = $mol_type_enforce<
		ReturnType< $shm_agent_history['catalog_select'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_link__sub_shm_agent_history_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_button_minor__title_shm_agent_history_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_agent_history_33 = $mol_type_enforce<
		ReturnType< $shm_agent_history['load_more'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_agent_history_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_agent_history_35 = $mol_type_enforce<
		ReturnType< $shm_agent_history['detail_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_agent_history_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_agent_history_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_agent_history_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_history_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_agent_message_card__message_theme_shm_agent_history_40 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_message_card['message_theme'] >
	>
	type $shm_agent_message_card__role_key_shm_agent_history_41 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_message_card['role_key'] >
	>
	type $shm_agent_message_card__role_shm_agent_history_42 = $mol_type_enforce<
		ReturnType< $shm_agent_history['agent_title'] >
		,
		ReturnType< $shm_agent_message_card['role'] >
	>
	type $shm_agent_message_card__time_shm_agent_history_43 = $mol_type_enforce<
		ReturnType< $shm_agent_history['previous_time'] >
		,
		ReturnType< $shm_agent_message_card['time'] >
	>
	type $shm_agent_message_card__text_shm_agent_history_44 = $mol_type_enforce<
		ReturnType< $shm_agent_history['previous_text'] >
		,
		ReturnType< $shm_agent_message_card['text'] >
	>
	type $shm_agent_message_card__content_shm_agent_history_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_agent_message_card['content'] >
	>
	type $mol_view__sub_shm_agent_history_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_agent_message_card__message_theme_shm_agent_history_47 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_message_card['message_theme'] >
	>
	type $shm_agent_message_card__role_key_shm_agent_history_48 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_agent_message_card['role_key'] >
	>
	type $shm_agent_message_card__role_shm_agent_history_49 = $mol_type_enforce<
		ReturnType< $shm_agent_history['agent_title'] >
		,
		ReturnType< $shm_agent_message_card['role'] >
	>
	type $shm_agent_message_card__time_shm_agent_history_50 = $mol_type_enforce<
		ReturnType< $shm_agent_history['last_time'] >
		,
		ReturnType< $shm_agent_message_card['time'] >
	>
	type $shm_agent_message_card__text_shm_agent_history_51 = $mol_type_enforce<
		ReturnType< $shm_agent_history['last_text'] >
		,
		ReturnType< $shm_agent_message_card['text'] >
	>
	type $shm_agent_message_card__content_shm_agent_history_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_agent_message_card['content'] >
	>
	type $mol_view__sub_shm_agent_history_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_agent_history_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_agent_history extends $mol_book2 {
		history_pages( ): readonly($mol_view)[]
		close( next?: any ): any
		Catalog_close( ): $mol_button_minor
		catalog_rows( ): readonly($mol_view)[]
		Catalog_list( ): $mol_list
		catalog_arg( id: any): Record<string, any>
		catalog_current( id: any): boolean
		catalog_select( id: any, next?: any ): any
		catalog_text( id: any): string
		Catalog_text( id: any): $mol_view
		catalog_time( id: any): string
		Catalog_time( id: any): $mol_view
		load_more( next?: any ): any
		detail_title( ): string
		Detail_close( ): $mol_button_minor
		detail_sections( ): readonly($mol_view)[]
		Detail_body( ): $mol_view
		user_time( ): string
		user_text( ): string
		User_text( ): $shm_agent_message_text
		User_message( ): $shm_agent_message_card
		User_messages( ): $mol_view
		User_scroll( ): $mol_scroll
		previous_rows( ): readonly($mol_view)[]
		Previous_messages( ): $mol_view
		Previous_list( ): $mol_scroll
		previous_time( id: any): string
		previous_text( id: any): string
		Previous_text( id: any): $shm_agent_message_text
		last_rows( ): readonly($mol_view)[]
		Last_messages( ): $mol_view
		Last_scroll( ): $mol_scroll
		last_time( ): string
		last_text( ): string
		Last_text( ): $shm_agent_message_text
		catalog_items( ): readonly(any)[]
		detail( ): any
		selected( next?: string ): string
		has_more( ): boolean
		agent_title( ): string
		Close_icon( ): $mol_icon_close
		pages( ): ReturnType< $shm_agent_history['history_pages'] >
		Catalog( ): $mol_page
		Catalog_link( id: any): $mol_link
		Catalog_more( ): $mol_button_minor
		Catalog_empty( ): $mol_view
		Detail( ): $mol_page
		User_panel( ): $mol_view
		Previous_panel( ): $mol_view
		Previous_message( id: any): $shm_agent_message_card
		Last_panel( ): $mol_view
		Last_message( ): $shm_agent_message_card
		No_previous( ): $mol_view
		No_answers( ): $mol_view
	}
	
}

//# sourceMappingURL=history.view.tree.d.ts.map